import { ISignInResponse } from 'shared/models/Auth'
import { IServerUser, IUser } from 'shared/models/User'
import { ISignIn } from 'shared/utils/types/Auth.type'

import { getUserType } from './utils/getUserType'

export class AuthConverter {
  convertUserData = (data: IServerUser): IUser => ({
    id: +data.id,
    balance: Math.floor(+data.balance * 100) / 100,
    currency: data.balance_currency,
    bonusBalance: Math.floor(+data.bonus_balance * 100) / 100,
    login: data.email,
    email: data.email,
    username: data.username,
    firstName: data.first_name,
    lastName: data.last_name,
    role: data.role,
    parent: data.parent,
    dateJoined: data.date_joined,
    isSelfRegistered: data.is_self_registered,
    userTypes: getUserType(data),
    isDocumentApproved: !data.needs_document_approve,
    kycVerifyStatus: data.kyc_documents_status,
    kycRejectReason: data.kyc_documents_reject_reason,
    kycRejectReasonCustom: data.kyc_reject_reason_custom,
  })

  convertSignInData = ({ access, refresh, ...userData }: ISignInResponse): ISignIn => {
    const user = this.convertUserData(userData)
    return {
      user,
      session: {
        access,
        refresh,
      },
    }
  }
}
